import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store"
import AppSettings from "@/settings/appSettings"

class PORTAL_PlanificareAnualaService {
  getODataStore() {
    return new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + "PORTAL_PlanificareAnuala",
      key: "ID",
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
      }
    });
  }

  save(data: any): Promise<any> {
    return http.clientPortalHROdata.post("/PORTAL_PlanificareAnuala", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getPlanificareDepartament(structId: string, an: number): Promise<any> {
    return http.clientPortalHR.get("/portal/planificare-departament", {
      params: { structId, an },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_PlanificareAnualaService();
